import React from "react";

function AmericanExpressCardIcon() {
  return (
    <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2569_2336)">
        <path
          d="M22 0H2C0.89543 0 0 0.89543 0 2V14C0 15.1046 0.89543 16 2 16H22C23.1046 16 24 15.1046 24 14V2C24 0.89543 23.1046 0 22 0Z"
          fill="#016FD0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.7642 13.3938V7.69238L23.9117 7.70149V9.27638L22.7388 10.5298L23.9117 11.7947V13.403H22.0391L21.0439 12.3048L20.0558 13.4071L13.7642 13.3938Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.4419 12.7692V8.32031H18.2142V9.3452H15.6633V10.0409H18.1534V11.0487H15.6633V11.732H18.2142V12.7692H14.4419Z"
          fill="#016FD0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.1954 12.7691L20.2827 10.5421L18.1953 8.32031H19.811L21.0865 9.73035L22.3656 8.32031H23.9117V8.35532L21.8689 10.5421L23.9117 12.706V12.7691H22.35L21.0519 11.3449L19.7671 12.7691H18.1954Z"
          fill="#016FD0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2374 2.63184H16.6834L17.5426 4.58269V2.63184H20.5624L21.0832 4.09341L21.6057 2.63184H23.9116V8.33323H11.7251L14.2374 2.63184Z"
          fill="#FFFFFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.7006 3.25195L12.7266 7.69712H14.0805L14.4529 6.80696H16.4708L16.843 7.69712H18.2306L16.2648 3.25195H14.7006ZM14.8702 5.80939L15.4622 4.39432L16.0538 5.80939H14.8702Z"
          fill="#016FD0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2119 7.69606V3.25098L20.115 3.25752L21.0943 5.99025L22.0799 3.25098H23.9115V7.69606L22.7329 7.70649V4.65314L21.6204 7.69606H20.5446L19.4089 4.64271V7.69606H18.2119Z"
          fill="#016FD0"
        />
      </g>
      <defs>
        <clipPath id="clip0_2569_2336">
          <rect width="24" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default AmericanExpressCardIcon;
